(function () {
    const $body = $('body');

    var slide = {
        $slide: null,
        $target: null,
        $contents: null,
        $slideinfo: null,
        $toggle: null,
        prev: null,
        isMobile: false,
        vPort: 'screen-sm',
        elementvPort: null,
        back: false,
        nested: false,
        multi: false,
        activeSlide: 0,
        oldInfo: [],
        off: null,
        clone: null,
        wait: false,
        backLabel: 'back',
        $elements: null,
        isQueue: false,
        isRTL: false,

        init: function () {
            slide.$slide =
                '<div class="w-slide"><div class="w-slide_head"><a href="#" class="w-slide__back"><i class=" icon-arrow_l" aria-hidden="true"></i>' +
                slide.backLabel +
                '</a><span class="w-slide__title__wrapper"><i class="icon-ground inline-icon"></i><span class="w-slide__title"></span></span></span></div><div class="w-slide__content"></div></div>';

            slide.$elements = $(slide.$slide);
            slide.displaySlideHtmlToPage();

            slide.$contents = slide.$elements.find('.w-slide__content');
            slide.$slideinfo = slide.$elements.find('.w-slide__title');
            slide.$back = slide.$elements.find('.w-slide__back');
            slide.$toggle = $('.w-slide__btn');

            slide.elementvPort = slide.vPort;
            slide.vPort = [];

            slide.customViewPorts();

            slide.$toggle.each(function (index) {
                slide.check.viewPort($(this), index);
                slide.responsive(index);
            });

            slide.additionalInitialization();
            slide.control();
            slide.additionalControls();
            if (typeof facetDateChart != 'undefined') {
                facetDateChart.control(); /*eslint-disable-line*/
            }

            if (UX.utils && UX.utils.isRTL()) {
                slide.isRTL = true;
            }
        },
        displaySlideHtmlToPage: () => {
            let $main = $('main');
            if ($main.length > 0) $main.append(slide.$elements);
            else $body.append(slide.$elements);
        },
        additionalInitialization: function () {},
        responsive: function (index) {
            $(document).on(slide.vPort[index] + '-on', function () {
                // Waiting for custom event that will be triggered by controller.js to activate responsive effects
                slide.off = false;
                slide.isQueue = false;

                $('.w-slide__btn').each(function () {
                    if ($(this).data('ctrl-res') === slide.vPort[index]) {
                        $(this).addClass('slide-active');
                    }
                });
            });

            $(document).on(slide.vPort[index] + '-off', function (e) {
                // Waiting for custom event that will be triggered by controller.js to activate responsive effects
                slide.off = true;
                slide.on.off(e);
                slide.isQueue = false;

                $('.w-slide__btn').each(function () {
                    if ($(this).data('ctrl-res') === slide.vPort[index]) {
                        $(this).removeClass('slide-active');
                    }
                });
            });

            $(document).on(slide.elementvPort + '-on', function (e) {
                // Waiting for custom event that will be triggered by controller.js to activate responsive effects
                slide.isMobile = true;
                slide.$elements.css('margin-top', 0);
                if ($('.w-slide.js--open').length) {
                    slide.back = true;
                    slide.on.hide(e);
                }
            });

            $(document).on(slide.elementvPort + '-off', function (e) {
                // Waiting for custom event that will be triggered by controller.js to activate responsive effects
                slide.isMobile = false;
                if ($('.w-slide.js--open').length) {
                    slide.back = true;
                    slide.on.hide(e);
                }
            });

            slide.additionalResponsive();
        },
        additionalResponsive: function () {},
        control: function () {
            $body.on('click', '.w-slide__btn', function (e) {
                if (slide.isQueue && slide.isMobile) {
                    e.stopImmediatePropagation();
                    $(this).off('click');
                    return false;
                }
                slide.isQueue = true;

                if ($(this).hasClass('disable')) {
                    e.stopPropagation();
                    e.preventDefault();
                    return;
                }

                if ($(this).hasClass('slide-active')) {
                    e.stopPropagation();
                    e.preventDefault();
                    slide.addTransition();
                    slide.$toggle = $(this);
                    slide.$target = $(slide.$toggle.data('slide-target'));
                    slide.back = false;

                    if ($(this).is('[id*=pane-pcw]') && UX.tab.check.empty($(this))) {
                        setTimeout(function () {
                            slide.on.show(e);
                        }, 3000);
                    } else {
                        slide.on.show(e);
                    }
                }
            });

            $body.on('click', '.w-slide__back, .w-slide__hide', function (e) {
                if ($(this).hasClass('w-slide__back')) {
                    e.preventDefault();
                }

                slide.back = true;
                slide.on.hide(e);
            });
        },
        additionalControls: function () {},
        addTransition: function () {
            $('.w-slide, .w-slide__content').css('transition', 'all 250ms');
        },
        removeTransition: function () {
            $('.w-slide, .w-slide__content').css('transition', '');
        },
        customViewPorts: function () {
            if ($('.journal-home').length) {
                slide.elementvPort = 'screen-md';
            }
        },
        setBackLabel: function () {
            slide.$back.html('<i class=" icon-arrow_l" aria-hidden="true"></i>' + slide.backLabel);
        },
        on: {
            show: function (e) {
                $(document).trigger('UX-detach');
                if (typeof jcf != 'undefined') {
                    jcf.destroy($('.range-slider__range')); /*eslint-disable-line*/
                }

                /**
                 * Fire "open" event
                 * this event is Cancelable: which means if e.preventDefault() is called then the slide will not open.
                 */
                const openingEvent = $.Event('slide:open');
                $(document).trigger(openingEvent, [slide]);
                if (openingEvent.isDefaultPrevented()) {
                    return;
                }

                if ($body.attr('data-active') !== 'undefined') {
                    UX.controller.check(e);
                }

                if (slide.$toggle.is('[data-full-screen]') && !slide.$toggle.data('[full-screen]') && !slide.isMobile)
                    $body.addClass('w-slide__not-fullWidth');
                else $body.removeClass('w-slide__not-fullWidth');

                slide.nested = slide.$toggle.parents('.w-slide__content').length > 0;
                slide.multi =
                    slide.$toggle.closest('.pill-list').length > 0 || slide.$toggle.is('[data-slide-target*="#pill"]');
                if (slide.$toggle.closest('.w-slide__pill').length > 0) {
                    slide.nested = false;
                    slide.multi = true;
                }

                const popupType = e.currentTarget?.getAttribute('aria-haspopup');
                if (popupType) slide.$elements.attr('role', popupType === 'true' ? 'menu' : popupType);

                slide.on.additionalShow();

                slide.$slideinfo.hide().removeClass('js--open');
                slide.backLabel = 'back';
                slide.setBackLabel();

                if (slide.nested) {
                    slide.on._nestSlide();
                }

                if (slide.multi) {
                    if (slide.activeSlide !== 0) {
                        slide.back = true;
                        slide.on.hide(e);
                    }

                    slide.activeSlide++;
                    slide.$elements
                        .addClass('w-slide__pill')
                        .find('.w-slide__content')
                        .append('<div class="w-slide__content nested--' + slide.activeSlide + '"></div>');
                    slide.$contents = $('.nested--' + slide.activeSlide);
                }

                slide.$contents.attr('original-target', slide.$toggle.data('slide-target'));

                if (slide.$target.hasClass('tab__pane')) {
                    slide.$target.closest('.tab__content').find('.tab__pane').removeClass('active');
                    slide.$target.addClass('active');
                }

                let label = slide.$toggle.text();
                if (slide.$toggle.is('[data-label]')) {
                    label = slide.$toggle.data('label');
                }

                //LIT-163835
                if (slide.$toggle.hasClass('loa') || slide.$toggle.parents('.loa.mobile-authors').length > 0) {
                    label = 'AUTHORS';
                }

                let clonedDiv = slide.$target.children();

                slide.on.destroyJcf(clonedDiv);

                if (slide.$toggle.is('[data-slide-clone]')) {
                    slide.clone = slide.$toggle.data('slide-clone');

                    if (slide.clone === 'self') {
                        clonedDiv = slide.$target;
                    }
                } else {
                    slide.clone = '';
                }

                slide.oldInfo.push(label);
                slide.$slideinfo.html(label);

                const isLoi = slide.$target.find('.loi').length > 0;
                if (isLoi) {
                    slide.$contents.append(clonedDiv.html());
                    $('.dropBlock-loi__holder .loi').remove();
                    slide.$contents.find('.loi__list').each(function () {
                        UX.loi.on.recalculate($(this));
                    });
                } else {
                    if (slide.clone === 'self') {
                        if (slide.nested || slide.multi) {
                            slide.$target.after('<div class="returnNestedDataSlideHere"></div>');
                        } else {
                            slide.$target.after('<div class="returnDataSlideHere"></div>');
                        }
                    } else {
                        if (slide.nested || slide.multi) {
                            slide.$target.append('<div class="returnNestedDataSlideHere"></div>');
                        } else {
                            slide.$target.append('<div class="returnDataSlideHere"></div>');
                        }
                    }

                    clonedDiv.appendTo(slide.$contents);

                    slide.on.rebuildJcf(slide.$contents);
                }

                // This is needed for refreshing the google ads iframe
                // because we are cloning it into element
                // for more info:  https://stackoverflow.com/questions/435391/refresh-a-div-that-has-a-google-ad-inside-it/12083756#12083756
                if (typeof googletag !== 'undefined' && typeof googletag.pubads !== 'undefined') { /*eslint-disable-line*/
                    googletag.pubads().refresh(); /*eslint-disable-line*/
                }
                $body.addClass('lock-screen slide-is-active').attr('data-active', 'slide');
                slide.$back.focus();

                const $coolBar = $('.coolBar');
                if ($coolBar.length) {
                    $coolBar.addClass('slide');
                }
                /*
                $('.w-slide__title').truncate({
                    lines: 1
                });
                */

                // "opened" event
                const openEvent = $.Event('slide:opened');

                if (slide.wait) {
                    setTimeout(function () {
                        slide.on._showSlide();
                        slide.on.slidePill();
                        $(document).trigger(openEvent, [slide]);
                    }, 150);
                    slide.wait = false;
                } else {
                    slide.on._showSlide();
                    $(document).trigger(openEvent, [slide]);
                }

                $(document).trigger('UX-attach');
            },
            _showSlide: function () {
                var slideWidth = '100%';

                var $slidedDiv = slide.$elements;
                if (slide.nested || slide.multi) {
                    $slidedDiv = slide.$contents;
                }

                if (!slide.$elements.hasClass('js--open') && slide.multi) {
                    $slidedDiv = $('[class*=nested--], .w-slide');
                }
                let translate = `-${slideWidth}`;
                if (slide.isRTL) {
                    translate = slideWidth;
                }

                $slidedDiv
                    .css('transform', `translateX(${translate})`)
                    .off()
                    .one('transitionend webkitTransitionEnd oTransitionEnd', function (e) {
                        e.stopPropagation();
                        slide.isQueue = false;
                        slide.removeTransition();
                    });
                slide.$slideinfo.show().addClass('js--open');
                slide.$elements.addClass('js--open');
                slide.on.additionalShowSlide();
            },
            _nestSlide: function () {
                slide.activeSlide++;
                slide.$contents.append('<div class="w-slide__content nested--' + slide.activeSlide + '"></div>');
                slide.$contents = $('.nested--' + slide.activeSlide);
            },
            additionalShow: function () {},
            additionalShowSlide: function () {},
            slidePill: function () {},
            hide: function (e) {
                const isInsideSlide = $(e.target).closest('.w-slide').length;
                /**
                 * Fire "close" event
                 * this event is Cancelable: which means if e.preventDefault() is called then the slide will not close.
                 */
                var closingEvent = $.Event('slide:close');
                $(document).trigger(closingEvent, [slide]);
                if (closingEvent.isDefaultPrevented()) {
                    return;
                }

                if (typeof e !== 'undefined' && $('.w-slide').hasClass('js--open')) {
                    if (!isInsideSlide) {
                        slide.back = true;
                    }
                }

                if (slide.back) {
                    slide.addTransition();
                    slide.$slideinfo.hide().removeClass('js--open');

                    slide.nested = true;

                    if (slide.activeSlide === 0) {
                        slide.nested = false;
                        slide.$contents = slide.$elements.children('.w-slide__content');
                    } else {
                        slide.$contents = $('.nested--' + slide.activeSlide);
                    }
                    slide.on.destroyJcf(slide.$contents);

                    let originalTarget = $(slide.$contents.attr('original-target'));
                    if (!originalTarget) {
                        originalTarget = $body;
                    }

                    const isLoi = slide.$elements.find('.loi').length > 0;

                    slide.on.beforeReturnSlideContent();

                    if (isLoi) {
                        const $dropBlockHolder = $('.dropBlock-loi__holder');
                        $dropBlockHolder.append(slide.$contents.html());
                        $dropBlockHolder.find('.loi__list').each(function () {
                            UX.loi.on.recalculate($(this));
                        });
                    } else {
                        if (slide.$contents.find('[class*=nested--]').length) {
                            slide.$contents.find('[class*=nested--]').remove();
                        }
                        slide.on._returnDataSlide(originalTarget);
                        slide.on.rebuildJcf(originalTarget);
                    }

                    slide.oldInfo.splice(slide.activeSlide, 1);
                    slide.$slideinfo.html(slide.oldInfo[slide.activeSlide - 1]);
                    if (slide.$toggle) {
                        slide.$toggle.focus();
                    }

                    if (slide.nested) {
                        slide.activeSlide--;
                        slide.on._hideSlide();
                        if (slide.multi) {
                            slide.$contents.remove();
                        }
                        slide.$contents = $('.nested--' + slide.activeSlide);
                        if (slide.activeSlide === 0) {
                            slide.$contents = slide.$elements.children('.w-slide__content');
                        }
                    } else {
                        slide.activeSlide = 0;
                        $('body, html').removeClass('lock-screen');
                        $body.removeClass('lock-screen slide-is-active').removeAttr('data-active');
                        const $coolBar = $('.coolBar');
                        if ($coolBar.length) {
                            $coolBar.removeClass('slide');
                        }

                        slide.on._hideSlide();
                        slide.$elements.removeClass('js--open');
                        slide.$elements.removeAttr('role');
                    }
                    slide.$slideinfo.show().addClass('js--open');

                    slide.backLabel = 'back';
                    slide.setBackLabel();
                    slide.on.additionalHide(e);

                    if (slide.$elements.hasClass('w-slide__pill')) {
                        while (slide.activeSlide > 0) {
                            slide.activeSlide--;
                            slide.on.hide(e);
                        }

                        if (
                            typeof e !== 'undefined' &&
                            ($(e.target).hasClass('w-slide__back') || $(e.currentTarget).hasClass('w-slide__back')) &&
                            slide.activeSlide === 0
                        ) {
                            slide.on.off(e);
                        }
                    }

                    if (!isInsideSlide && !(typeof e !== 'undefined' && $(e.target).closest('.pill-list').length)) {
                        slide.on.off(e);
                    }

                    slide.removeTransition();
                }

                // This is needed for refreshing the google ads iframe
                // because we are cloning it into element
                // for more info:  https://stackoverflow.com/questions/435391/refresh-a-div-that-has-a-google-ad-inside-it/12083756#12083756
                if (typeof googletag !== 'undefined' && typeof googletag.pubads !== 'undefined') { /*eslint-disable-line*/
                    googletag.pubads().refresh(); /*eslint-disable-line*/
                }

                // "closed" event
                const closeEvent = $.Event('slide:closed');
                $(document).trigger(closeEvent, [slide]);
            },
            _hideSlide: function () {
                let updateTarget = slide.$elements;
                if (slide.nested) updateTarget = slide.$contents;

                updateTarget
                    .css('transform', 'translateX(0vw)')
                    .off()
                    .one('transitionend webkitTransitionEnd oTransitionEnd', function (e) {
                        e.stopPropagation();
                        if (slide.back)
                            if (!slide.nested) slide.$contents.empty();
                            else $(this).remove();
                    });
            },
            _returnDataSlide: function (originalTarget) {
                const returnDataSlideHere =
                    slide.nested || slide.multi ? '.returnNestedDataSlideHere' : '.returnDataSlideHere';
                const $returnDataSlideHere =
                    slide.clone === 'self' ? $(returnDataSlideHere) : $(returnDataSlideHere, originalTarget);
                slide.$contents.children().appendTo($returnDataSlideHere.parent());
                $returnDataSlideHere.remove();
            },
            additionalHide: function (e) {},
            beforeReturnSlideContent: function () {},
            off: function (e) {
                slide.$slideinfo.hide().removeClass('js--open');

                $('.pill-list li').removeClass('pill-active');

                const isLoi = slide.$elements.find('.loi').length > 0;

                if (isLoi) {
                    slide.$contents = $('.loi').closest('.w-slide__content');

                    const $dropBlockHolder = $('.dropBlock-loi__holder');
                    $dropBlockHolder.append(slide.$contents.html());
                    $dropBlockHolder.find('.loi__list').each(function () {
                        UX.loi.on.recalculate($(this));
                    });
                }
                $('body, html').removeClass('lock-screen');
                $body.removeClass('lock-screen slide-is-active').removeAttr('data-active');
                $('.coolBar').removeClass('slide');
                slide.$contents = slide.$elements.children('.w-slide__content');
                slide.$elements
                    .css('transform', 'translateX(0vw)')
                    .off()
                    .one('transitionend webkitTransitionEnd oTransitionEnd', function (e) {
                        e.stopPropagation();
                        slide.$elements.removeClass('js--open');
                        if (slide.off) {
                            $('.w-slide').removeClass('w-slide__pill');
                            slide.$contents.empty();
                        }
                    });
                slide.off = false;
                slide.on.additionalOff(e);
            },
            additionalOff: function (e) {},
            destroyJcf: function ($el) {
                if (typeof jcf != 'undefined') {
                    jcf.destroy($el.find('.jcf')); /*eslint-disable-line*/
                }
            },
            rebuildJcf: function ($el) {
                if (typeof jcf != 'undefined') {
                    jcf.replace($el.find('.jcf')); /*eslint-disable-line*/
                }
            },
        },
        check: {
            viewPort: function ($el, index) {
                if (typeof $el.data('ctrl-res') !== 'undefined') {
                    slide.vPort[index] = $el.data('ctrl-res');
                } else {
                    $el.data('ctrl-res', slide.elementvPort);
                    slide.vPort[index] = slide.elementvPort;
                }
            },
        },
    };

    UX.slide = slide; // add to global namespace
})();
